import React from 'react';

import { FormattedMessageWrappedInSpan } from '../misc';

export default function SinglePhotoMsg(props) {
  return <FormattedMessageWrappedInSpan id="messages.singlePhoto" defaultMessage="Single Photo" />;
}
